import script from "./Catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalog.vue?vue&type=script&setup=true&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=31b1ed10&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b1ed10"]])

export default __exports__